export enum ThemeType {
  DARK = "dark",
  LIGHT = "light",
  CUSTOM = "custom",
}
//export type MouseEventActions = ThemeType;
